import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export const StructurePicker = ({ formData, name, formContext, onChange, schema }) => {
  const structures = [
    { value: 'artisan', label: 'Artisan, ferme' },
    { value: 'base_loisir', label: 'Base de loisir' },
    { value: 'chateau', label: 'Château' },
    { value: 'collectivite', label: 'Collectivité' },
    { value: 'espace_naturel', label: 'Espace naturel' },
    { value: 'grottes', label: 'Grottes' },
    { value: 'hebergement', label: 'Hébergement' },
    { value: 'montagne', label: 'Montagne' },
    { value: 'musee', label: 'Musée' },
    { value: 'office_tourisme', label: 'Office de tourisme' },
    { value: 'parc_accrobranche', label: 'Parc accrobranche' },
    { value: 'parc_animalier_botanique', label: 'Parc animalier et botanique' },
    { value: 'prescripteur', label: 'Prescripteur' },
    { value: 'prive', label: 'Privé' },
    { value: 'public', label: 'Public' }
  ]
  const [value, setValue] = useState([])

  useEffect(() => {
    setValue(structures.filter(structure => (formData || []).includes(structure.value)))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData])

  return (
    <>
      <label className="control-label" htmlFor={name}>
        {schema.title}
      </label>
      <Select
        value={value}
        onChange={structures => onChange((structures || []).map(structure => structure.value))}
        options={structures}
        isMulti={true}
        closeMenuOnSelect={false}
        menuPortalTarget={document.body}
        placeholder={'Sélectionnez un ou plusieurs types de structure'}
        menuPlacement="auto"
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </>
  )
}
